
const InitializePeopleIconRotator = () => {

  const personalIcons = [...document.querySelectorAll('.person-icon')];
  
  personalIcons.forEach( (pi, i) => {
    if( i % 2 ) {
      pi.classList.add('show');
    }
  });
  
  function rotatePersonalIcons() {
    
    const shown = personalIcons.filter( pi => pi.classList.contains('show') );
    const hidden = personalIcons.filter( pi => !pi.classList.contains('show') );

    const getRandomIndexes = ( arr, howMany = 1 ) => {
      
      if( arr.length < howMany ) {
        return undefined;
      }
      
      let indexes = [];

      while(indexes.length < howMany ) {
        indexes.push(~~(Math.random() * shown.length))
        indexes = [...new Set(indexes)];
      }

      return indexes;
    }

    const amountToFade = 4;
    const speed = 1500;
    
    if( shown.length > amountToFade ) {
      const indexes = getRandomIndexes( shown, amountToFade );

      if( indexes ) {
        indexes.forEach( i => {
          shown[i].classList.remove('show');
        })
      }
    }
    
    if( hidden.length > amountToFade ) {
      const indexes = getRandomIndexes( hidden, amountToFade );

      if( indexes ) {
        indexes.forEach( i => {
          hidden[i].classList.add('show');
        })
      }
    }
    
    setTimeout( rotatePersonalIcons, speed );
  }
  
  setTimeout( rotatePersonalIcons, 1500 );
}

export {InitializePeopleIconRotator};